import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import { useGetCalendarEntriesQuery } from "../../../api/plamo-api";


const SingleCalendarEntryLoader = ({ employeeId, monthKey, addEntries, removeEntries }: any) => {
  const startDate = monthKey.replace('/', '-') + '-01T00:00:00.000'
  const endDate = dayjs(startDate).add(1, 'months').format('YYYY-MM-DDTHH:mm:ss') + '.000'
  const { data: calendarEntries } = useGetCalendarEntriesQuery({ f: JSON.stringify({ "calendarSeries.employee.id": { c: "EQ", v: employeeId }, "startTime": { c: "BTW", v: startDate, v2: endDate, t: "DATE" } }) }) as any;


  useEffect(() => {
    if(calendarEntries?.items?.length) {
      addEntries(monthKey, calendarEntries.items);
      
      return () => removeEntries(monthKey);
    }
  }, [calendarEntries, monthKey, addEntries, removeEntries])

  return <></>
}

const CalendarEntriesLoader = ({ months, onEntriesLoaded, employeeId }: any) => {
  const [entries, setEntries] = useState<any[]>([])
  
  const addEntries = useCallback((monthKey: string, entries: any) => {
    setEntries(existingEntries => ({...existingEntries, [monthKey]: entries.filter((e: any) => !e.cancelled)}));
  }, [setEntries])

  const removeEntries = useCallback((monthKey: any) => {
    setEntries(existingEntries => ({...existingEntries, [monthKey]: undefined}));
  }, [setEntries]);

  useEffect(() => {
    onEntriesLoaded(entries);
  }, [entries, onEntriesLoaded])

  return <>
  {
    months.map((monthKey: string) => <SingleCalendarEntryLoader key={monthKey} monthKey={monthKey} addEntries={addEntries} removeEntries={removeEntries} employeeId={employeeId} />)
  }
  </>
}

export default CalendarEntriesLoader;